<template>
  <div>
    <div
      class="search_result applicants_search_result"
      :key="'applicant_' + applicant.resource_id"
      v-for="applicant in results"
    >
      <div dir="ltr" class="is-flex is-align-items-center is-justify-content-flex-end">
        <b>Applicant: (ID: {{ applicant.resource_id }})&nbsp;</b>
        <link-entity :payload="applicant"></link-entity>
      </div>
      <p><b>Phone: </b>{{ applicant.phone_number }}</p>
      <p><b>Email: </b>{{ applicant.email }}</p>
      <p><b>Status: </b>{{ applicant.status }}</p>
      <p><b>Tags: </b>{{ applicant.tags }}</p>
      <p>
        <b>Last Login: </b
        >{{ time_helper.makeTimeReadable(applicant.last_login) }}
      </p>
      <p><b>Message: </b>{{ applicant.message }}</p>
    </div>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
import TimeHelper from '@/custom/classes/time_helper.js'
export default {
  name: 'search-modal-applicants',
  props: ['results'],
  data () {
    return {
      time_helper: new TimeHelper()
    }
  },
  components: {
    LinkEntity
  }
}
</script>
<style scoped>
  .search_result {
    cursor: auto !important;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
</style>
